import { axiosInstance } from '../../../Interceptors/axiosInterceptor';
import { apiUrl } from '../../../Utils/Environment';

const TassoService = {
  // Poll order status
  getTassoOrderStatus: (tassoOrderId, orderId) => {
    let query = '';
    if (tassoOrderId) query = `tasso_order_id=${tassoOrderId}`;
    else if (orderId) query = `order_id=${orderId}`;

    return axiosInstance.get(`${apiUrl}/api/accounts/orders/status/?${query}`, { loaderKey: 'get-tasso-status' });
  },

  // Fetch clinical results
  getTassoResults: (projectId) => {
    return axiosInstance.get(`${apiUrl}/api/reports/patient/${projectId}/reports/`, { loaderKey: 'get-tasso-results' });
  },

  // Update status (Demo/Admin)
  updateTassoStatus: (tassoOrderId, status) => {
    return axiosInstance.put(
      `${apiUrl}/api/accounts/orders/status/update/`,
      { tasso_order_id: tassoOrderId, status },
      { loaderKey: 'update-tasso-status' }
    );
  },
};

export default TassoService;
